// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","emojiBar":"U76tnB_s","mobile":"mobile","title":"VghOkEMD","reactions":"khrwposh","input":"iSh4ho2R","content":"xUCDPk2r","emoji":"RwdWsr2A"};